import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { backend } from "../../../../path";
import DashboardSidebarMain from "../../dashsidebar";
import { useNavigate } from "react-router-dom";
import HeaderDashMain from "../../../layout/header/dash header";
import Editor from "../../layouts/editor";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Helmet } from "react-helmet";


function DashboardCouponForm() {
  const [formData, setFormData] = useState({
    category_id: [],
    discount_type: "0"
  });
  const navigate = useNavigate();
  const [carousel, setCarousel] = useState();
  const [categories, setCategories] = useState([]);
  const [categorySearch, setCategorySearch] = useState("");
  const [categoryOpen, setCategoryOpen] = useState(false);

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const type = authenticated.type;
  const user_id = authenticated.user_id;

  useEffect(() => {
    // Fetch categories
    fetch(backend + "getcategory", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCategories(data || []);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const handlefileupload = (e) => {
    console.log("File selected:", e.target.files[0]);
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "carouselupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          carousel: data,
        });
        setCarousel = data;
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };

  const handleSubmit = () => {

    fetch(backend + "addcoupon", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          console.log("success");

          // Additional success handling code here
          toast.success("Coupon Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        navigate("/banner");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleEditorSave = (editorContent) => {
    setFormData({
      ...formData,
      description: editorContent.content,
    });
  };
  return (
    <>
      <Helmet>
        <title>KS</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 d-none d-lg-flex"> */}
          <DashboardSidebarMain />
          {/* </div> */}
          <div className="col-lg-12">
            <div className="login_wrap widget-taber-content background-white">
              <div className="padding_eight_all bg-white">
                <div className="padding_eight_all bg-white">
                  <div className="d-flex justify-content-between mb-20 mt-20">
                    <h3 className="">Add Coupon</h3>
                    <a href="/coupons">
                      <button
                        type="button"
                        className="btn btn-fill-out btn-block hover-up"
                      //   onClick={handleSubmit}
                      >
                        Back
                      </button>
                    </a>
                  </div>
                  <br></br>
                </div>
                <form
                // onSubmit={handleSubmit}
                >
                  <div className="form__content">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Coupon Title</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="category_name"
                            id="txt-name"
                            type="text"
                            required
                            value={formData.title || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                title: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Code</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="category_name"
                            id="txt-name"
                            type="text"
                            required
                            value={formData.code || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                code: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Amount</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="category_name"
                            id="txt-name"
                            type="text"
                            required
                            value={formData.amount || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                amount: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Minimum Amount</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="category_name"
                            id="txt-name"
                            type="text"
                            required
                            value={formData.min_amount || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                min_amount: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Max Amount</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="max_amount"
                            id="txt-max-amount"
                            type="text"
                            required
                            value={formData.max_amount || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                max_amount: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Discount Type</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <select
                            className="form-control"
                            name="discount_type"
                            id="discount-type"
                            required
                            value={formData.discount_type || "0"}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                discount_type: e.target.value,
                              })
                            }
                          >
                            <option value="0">Amount</option>
                            <option value="1">Percentage</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">End Date</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="category_name"
                            id="txt-name"
                            type="date"
                            required
                            value={formData.end_date || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                end_date: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group" style={{ position: "relative" }}>
                          <label htmlFor="category">Categories</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <div
                            tabIndex={0}
                            onBlur={(e) => {
                              if (!e.currentTarget.contains(e.relatedTarget)) setCategoryOpen(false);
                            }}
                          >
                            <div
                              className="form-control"
                              style={{ display: "flex", alignItems: "center", minHeight: "42px", cursor: "pointer" }}
                              onClick={() => setCategoryOpen((o) => !o)}
                            >
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                {(formData.category_id || []).length === 0 ? (
                                  <span style={{ color: "#6c757d" }}>Select categories</span>
                                ) : (
                                  (formData.category_id || []).slice(0, 3).map((id) => {
                                    const cat = (categories || []).find((c) => String(c.category_id) === String(id));
                                    if (!cat) return null;
                                    return (
                                      <span key={id} className="badge" style={{ background: "#eef2ff", color: "#1f3bb3", padding: "6px 10px", borderRadius: "12px" }}>
                                        {cat.category_name}
                                      </span>
                                    );
                                  })
                                )}
                                {(formData.category_id || []).length > 3 && (
                                  <span className="badge" style={{ background: "#f1f3f5", color: "#495057", padding: "6px 10px", borderRadius: "12px" }}>
                                    +{(formData.category_id || []).length - 3}
                                  </span>
                                )}
                              </div>
                              <Icon icon={categoryOpen ? "mdi:chevron-up" : "mdi:chevron-down"} />
                            </div>
                            {categoryOpen && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 10,
                                  left: 0,
                                  right: 0,
                                  marginTop: "4px",
                                  border: "1px solid #e9ecef",
                                  borderRadius: "4px",
                                  background: "#fff",
                                  boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
                                  padding: "10px",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search categories"
                                  value={categorySearch}
                                  onChange={(e) => setCategorySearch(e.target.value)}
                                  style={{ marginBottom: "10px" }}
                                />
                                <div style={{ maxHeight: "220px", overflowY: "auto" }}>
                                  {(categories || [])
                                    ?.filter((c) =>
                                      (c.category_name || "").toLowerCase().includes(categorySearch.toLowerCase())
                                    )
                                    ?.map((category) => {
                                      const idStr = String(category.category_id);
                                      const selected = (formData.category_id || []).includes(idStr);
                                      return (
                                        <div
                                          key={category.category_id}
                                          role="option"
                                          aria-selected={selected}
                                          tabIndex={0}
                                          onClick={() => {
                                            const current = formData.category_id || [];
                                            const next = selected
                                              ? current?.filter((x) => x !== idStr)
                                              : Array.from(new Set([...current, idStr]));
                                            setFormData({ ...formData, category_id: next });
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                              e.preventDefault();
                                              const current = formData.category_id || [];
                                              const next = selected
                                                ? current?.filter((x) => x !== idStr)
                                                : Array.from(new Set([...current, idStr]));
                                              setFormData({ ...formData, category_id: next });
                                            }
                                          }}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "8px 10px",
                                            marginBottom: "6px",
                                            cursor: "pointer",
                                            borderRadius: "6px",
                                            background: selected ? "#f0f6ff" : "transparent",
                                            border: selected ? "1px solid #cfe2ff" : "1px solid transparent",
                                          }}
                                        >
                                          <span style={{ marginLeft: "2px" }}>{category.category_name}</span>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-fill-out btn-block hover-up"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                  <br></br>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
export default DashboardCouponForm;
